import { render, staticRenderFns } from "./clause.vue?vue&type=template&id=93965c50&scoped=true"
import script from "./clause.vue?vue&type=script&lang=js"
export * from "./clause.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/home/clause.css?vue&type=style&index=0&id=93965c50&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93965c50",
  null
  
)

export default component.exports